import {computed, reactive, ref, getCurrentInstance, onMounted, watch, nextTick} from 'vue';
import {useValidateControl} from '../../../composables/validateControl';

export const useCellEditor = ({props, emit}) => {
  const errorProvider = reactive({});
  const isEditor = ref(false);
  const cellData = ref(null);
  const isSelected = ref(false);
  const {proxy} = getCurrentInstance();
  proxy._isGridEditor = true;
  const {errorMessage, validate, clearValidate} = useValidateControl({
    props,
  });

  const listeners = computed(() => {
    return {
      [proxy.$ms.constant.CustomEvent.MsKeydown]: (e, value) => {
        emit(proxy.$ms.constant.CustomEvent.MsKeydown, e, value, props.col);
      },
      comboboxLoadData: payload => {
        if (props.propsData.comboboxLoadData && typeof props.propsData.comboboxLoadData === 'function') {
          props.propsData.comboboxLoadData(payload, props.dataRow, props.col, props.customData);
        } else {
          emit('comboboxLoadData', payload, props.col);
        }
      },
      paste: e => {
        if (proxy.allowCopyFromExcel) {
          emit('pasteInput', e, proxy.col);
        }
      },
    };
  });

  const activeCell = () => {
    if(props.disabled){
      return;
    }
    isEditor.value = proxy.col?.linkedForm ? false : true;
    return new Promise((resolve, reject) => {
      nextTick(() => {
        resolve();
      });
    });
  };

  const inactiveCell = () => {
    isEditor.value = false;
    return new Promise((resolve, reject) => {
      nextTick(() => {
        resolve(proxy);
        // Chạy bất đồng bộ validate sau khi tất cả các action đã thực hiện xong ở resolve
        setTimeout(() => {
          validate();
        }, 0);
      });
    });
  };

  const findEditor = () => {
    const inputEl = proxy.$el.querySelector('input');
    if (inputEl) {
      setTimeout(() => {
        inputEl.focus();
        inputEl.select();
      }, 0);
    }
  };

  const getValue = () => {
    return props.dataRow[props.col.dataField];
  };

  return {
    // Flag ô này đang được edit
    isEditor,
    errorProvider,
    isSelected,
    listeners,
    inactiveCell,
    activeCell,
    cellData,
    findEditor,
    errorMessage,
    validate,
    getValue,
    clearValidate,
  }; // Chứa error object // //Các event dùng chung //Hàm inactive edit cell // Hamf active edit cell // Data của cell // Tìm editor(thẻ input)
};
